import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BluetoothDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bluetooth_disabled"}/>
}
